import api from './api';
import { Dress, PaginatedResponse, ApiResponse } from '../types';

interface DressFilters {
  page?: number;
  limit?: number;
  category?: string;
  categories?: string[];
  designerId?: string;
  designerIds?: string[];
  search?: string;
  sortBy?: string;
}

class DressService {
  async getDresses(filters: DressFilters = {}): Promise<PaginatedResponse<Dress>> {
    const response = await api.get<PaginatedResponse<Dress>>('/dresses', filters);
    return response.data;
  }

  async getDress(id: string): Promise<Dress> {
    const response = await api.get<ApiResponse<Dress>>(`/dresses/${id}`);
    return response.data.data;
  }

  async getStyleMatcherDresses(): Promise<Dress[]> {
    const response = await api.get<ApiResponse<Dress[]>>('/style-matcher/dresses');
    return response.data.data;
  }
}

export default new DressService();